import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../../context/axios";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const WishlistTable = () => {
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
          toast.error("User not logged in");
          setLoading(false);
          return;
        }
        const token = localStorage.getItem("token");
        const res = await axios.get(`/wishlist/${user._id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setWishlist(res.data);
      } catch (error) {
        toast.error("Failed to load wishlist");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchWishlist();
  }, []);

  const handleRemove = async (tourId) => {
    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      await axios.delete(`/wishlist/remove`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { userId: user._id, tourId },
      });
      // setWishlist((prev) => prev.filter((item) => item.tourId._id !== tourId));
      setWishlist((prev) =>
        prev.filter((item) => item.tourId && item.tourId._id !== tourId)
      );

      toast.success("Removed from wishlist");
    } catch (error) {
      toast.error("Failed to remove from wishlist");
      console.error(error);
    }
  };

  if (loading) {
    return (
      <p className="text-center mt-10 text-gray-600">Loading wishlist...</p>
    );
  }

  if (!wishlist.length) {
    return (
      <div className="h-[90vh] flex flex-col items-center justify-center text-center px-4 bg-white rounded-xl">
        <img
          src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
          alt="No data"
          className="w-24 h-24 mb-4 opacity-70"
        />
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          Your Wishlist is Empty
        </h2>
        <p className="text-gray-500 mb-4 max-w-md">
          You haven’t added any packages to your wishlist yet. Explore tours and
          add your favorites here to plan your next trip!
        </p>
      </div>
    );
  }

  return (
    <>
      <Toaster position="top-right" />
      <div className="overflow-x-auto p-6 w-screen">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">
          Your Wishlist Tours
        </h1>
        <table className="min-w-full border-collapse rounded-lg overflow-hidden shadow-lg">
          <thead>
            <tr className="bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-left">
              <th className="px-6 py-3">Sr No.</th>
              <th className="px-6 py-3">Image</th>
              <th className="px-6 py-3">Title</th>
              <th className="px-6 py-3">Duration</th>
              <th className="px-6 py-3">Price</th>
              <th className="px-6 py-3">Region</th>
              <th className="px-6 py-3">City</th>
              <th className="px-6 py-3">Action</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {wishlist.map(({ tourId }, index) => {
              if (!tourId) return null; // skip null tourId entries
              return (
                <tr
                  key={tourId._id}
                  className="hover:bg-gray-50 cursor-default"
                >
                  <td className="px-6 py-4 whitespace-nowrap text-gray-700 font-medium">
                    {index + 1}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <img
                      onClick={() => navigate(`/tours/${tourId._id}`)}
                      src={tourId.img || tourId.image || ""}
                      alt={tourId.title}
                      className="w-20 h-14 object-cover rounded-lg cursor-pointer hover:scale-105 transition-transform duration-200"
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-800 font-semibold">
                    {tourId.title}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">
                    {tourId.duration
                      ? `${tourId.duration.day} Days, ${tourId.duration.night} Nights`
                      : "N/A"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-green-600 font-semibold">
                    €{tourId.price}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">
                    {tourId.region}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">
                    {tourId.mainCity}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <button
                      onClick={() => handleRemove(tourId._id)}
                      className="text-red-600 hover:text-red-800 font-semibold transition-colors"
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default WishlistTable;

// import React from "react";
// import { MdTour } from "react-icons/md";
// import { BiMapPin } from "react-icons/bi";
// import tourData from "../../assets/data/tours";

// const DaysShow = () => {
//   const tour = tourData.find((tour) => tour.id === 1);
//   //destructure
//   const { dayDetails } = tour;
//   return (
//     <div>
//       <div className="text-5xl  mb-11">
//         <p>Day Description</p>
//       </div>
//       <div>
//         <ul
//           class="relative m-0 w-full list-none overflow-hidden p-0 transition-[height] duration-200 ease-in-out"
//           data-te-stepper-init
//           data-te-stepper-type="vertical"
//         >
//           {/* <!--First item--> */}
//           {dayDetails.map((details) => (
//             <li
//               data-te-stepper-step-ref
//               class="relative h-fit after:absolute after:left-[2.45rem] after:top-[3.6rem] after:mt-px after:h-[calc(100%-2.45rem)] after:w-px after:bg-[#e0e0e0] after:content-[''] dark:after:bg-neutral-600"
//             >
//               <div
//                 data-te-stepper-head-ref
//                 class="flex cursor-pointer items-center p-6 leading-[1.3rem] no-underline after:bg-[#e0e0e0] after:content-[''] hover:bg-[#f9f9f9] focus:outline-none dark:after:bg-neutral-600 dark:hover:bg-[#41A4FF]"
//               >
//                 <span
//                   data-te-stepper-head-icon-ref
//                   class="mr-3 flex h-[1.938rem] w-[1.938rem] items-center justify-center rounded-full bg-[#ebedef] text-xl font-medium text-[#40464f]"
//                 >
//                   {details.day}
//                 </span>
//                 <span
//                   data-te-stepper-head-text-ref
//                   class="text-neutral-500 text-2xl after:absolute after:flex after:text-[0.8rem] after:content-[data-content] dark:text-black"
//                 >
//                   <div className="flex flex-row gap-3">
//                     Day {details.day}
//                     {details.day === "1" ? (
//                       <BiMapPin className="text-red-500 text-3xl" />
//                     ) : (
//                       <MdTour className="text-[#15A891] text-3xl" />
//                     )}
//                   </div>
//                 </span>
//               </div>
//               <div
//                 data-te-stepper-content-ref
//                 class="transition-[height, margin-bottom, padding-top, padding-bottom]
//          text-xl left-0 overflow-hidden pb-6  duration-300 ease-in-out pl-24"
//               >
//                 {details.desc}
//               </div>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default DaysShow;
